var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "#002E9E",
    rx: 23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.99 16.723a.767.767 0 0 1-.216.667l-3.077 3.077a.765.765 0 0 1-.887.144l-1.556-.777-4.736 4.736a.769.769 0 1 1-1.087-1.088l4.736-4.736-.777-1.556a.767.767 0 0 1 .144-.887l3.077-3.077a.769.769 0 0 1 1.232.2l.91 1.821 1.822.911a.765.765 0 0 1 .414.565ZM22.948 19.79a3.788 3.788 0 0 0-.975-.123 4.369 4.369 0 0 0-4.359 4.359c0 2.4 1.96 4.359 4.36 4.359 2.4 0 4.358-1.96 4.358-4.36 0-.338-.04-.666-.123-.974l-2.605 2.606a2.263 2.263 0 0 1-1.63.676c-.616 0-1.2-.235-1.632-.676a2.303 2.303 0 0 1 0-3.262l2.606-2.605Zm6.205 2.44c-.35 0-.708-.081-1.026-.245l-.574-.277-.113.113c.277.677.43 1.425.43 2.205a5.905 5.905 0 0 1-5.897 5.897 5.905 5.905 0 0 1-5.897-5.897 5.905 5.905 0 0 1 5.897-5.898c.78 0 1.528.154 2.205.431l.113-.113-.277-.564a2.293 2.293 0 0 1 .298-2.523 8.811 8.811 0 0 0-2.339-.307c-4.954 0-8.974 4.02-8.974 8.974C13 28.98 17.02 33 21.974 33c4.954 0 8.974-4.02 8.974-8.974 0-.81-.102-1.59-.307-2.339-.41.349-.944.544-1.487.544Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.1dce7ec9207a95c54393b67d644b229f.svg";
export { ForwardRef as ReactComponent };